module.exports = __webpack_public_path__ + "img/cb9-r-011.2264ea6a.gif";